// Generated by npm run generate-i18n-catalogs. Do not edit directly.

export const catalogKo = {
  "controls": {
    "boot": "부팅",
    "reset": "재설정",
    "copyScreen": "화면 복사",
    "copyText": "텍스트 복사",
    "pasteText": "텍스트 붙여넣기",
    "saveState": "상태 저장",
    "restoreState": "상태 복원",
    "toggleSound": "소리 토글",
    "settings": "설정",
    "debugPanel": "디버그 패널",
    "infoPanel": "정보 패널",
    "reportIssue": "문제 보고",
    "privacyPolicy": "개인정보 처리방침"
  },
  "config": {
    "speed": "속도",
    "display": "디스플레이 설정",
    "theme": "테마",
    "openRetroControlPanel": "제어판",
    "resetSettings": "모든 설정 재설정",
    "useOpenApple": "{{modKey}} 키를 Open Apple 키로 사용",
    "useShortcuts": "{{modKey}} 키를 키보드 단축키로 사용",
    "useArrowKeys": "화살표 키를 조이스틱으로 사용",
    "scanlines": "CRT 스캔라인",
    "ghosting": "잔상 효과",
    "crtDistortion": "CRT 왜곡",
    "joystick": "조이스틱 설정"
  },
  "machine": {
    "slotConfigurator": "확장 슬롯"
  },
  "speed": {
    "snail": "달팽이 속도 (0.1 MHz)",
    "slow": "느린 속도 (0.5 MHz)",
    "normal": "정상 속도 (1 MHz)",
    "fast": "빠른 속도 (4 MHz)",
    "warp": "터무니없는 속도"
  },
  "colors": {
    "color": "컬러",
    "nofringe": "컬러 (프린지 없음)",
    "green": "녹색",
    "amber": "호박색",
    "white": "흑백",
    "inverse": "흑백 (역순)"
  },
  "themes": {
    "classic": "클래식",
    "dark": "다크",
    "minimal": "미니멀"
  },
  "debug": {
    "helpPanel": "도움말 패널 표시",
    "debugPanel": "디버그 패널 표시",
    "expectinPanel": "Apple exPectin 패널 표시",
    "helpTab": "도움말",
    "debugTab": "디버깅",
    "breakpoints": "중단점",
    "memory": "메모리",
    "stack": "스택",
    "state": "CPU 상태",
    "registers": "레지스터",
    "flags": "플래그",
    "step": "단계",
    "stepOver": "단계 건너뛰기",
    "stepInto": "단계 진입",
    "stepOut": "단계 나가기",
    "resume": "재개",
    "pause": "일시 정지",
    "loadSymbolTable": "심볼 테이블 로드",
    "disassembly": "디스어셈블리"
  },
  "tour": {
    "welcome": "Apple2TS 에뮬레이터에 오신 것을 환영합니다!",
    "clickNext": "더 자세히 알아보려면 다음 버튼을 누르세요.",
    "bootButton": "여기를 클릭하여 에뮬레이터를 시작하세요.",
    "resetButton": "여기를 클릭하여 Apple II를 재설정하고 재부팅하거나 BASIC에 진입하세요.",
    "diskImages": "설치된 디스크 이미지 중 하나를 선택하세요.",
    "floppyDisks": "또는 플로피 디스크 아이콘 중 하나를 클릭하여 디스크 이미지를 로드하세요.",
    "saveRestore": "이 버튼들을 사용하여 에뮬레이터의 완전한 상태를 저장하고 복원할 수 있습니다.",
    "themeButton": "여기를 클릭하여 에뮬레이터 UI 테마를 변경하세요.",
    "endTour": "투어의 끝에 도달했습니다. 지구본 투어 버튼을 클릭하여 다른 투어를 시도하거나, 완료를 눌러 에뮬레이터 사용을 시작하세요.",
    "tourSelectorHint": "지구본 투어 버튼을 클릭하여 다른 투어를 시도하거나 종료를 눌러 에뮬레이터 사용을 시작하십시오。",
    "settingsWelcome": "Apple2TS는 에뮬레이터와 Apple II 모두를 위한 완전한 제어 세트를 가지고 있습니다. 더 자세히 알아보려면 다음 버튼을 누르세요.",
    "mainControls": "여기서 Apple II를 부팅하고 재설정하고, 상태를 복원하고 저장하고, 화면을 복사하거나 에뮬레이터에 텍스트를 붙여넣을 수 있습니다.",
    "snapshot": "언제든지 현재 에뮬레이터 상태의 스냅샷을 찍고, 이전 상태로 시간을 되돌리거나, 다시 빨리 감기할 수 있습니다. 모든 현재 스냅샷과 함께 에뮬레이터 상태를 저장할 수도 있습니다.",
    "pauseButton": "언제든지 에뮬레이터를 일시 정지하여 6502 프로세서를 동결시킬 수 있습니다. 이는 게임에서 액션을 일시 정지하거나 디버거에 진입하는 데 유용합니다.",
    "debugButton": "벌레를 클릭하여 6502 프로세서의 내부 상태를 볼 수 있는 디버그 모드에 진입하세요. 다시 클릭하여 정상 모드로 돌아갑니다.",
    "configButtons": "아래쪽 버튼 행은 에뮬레이터 속도, 화면 색상, 소리 음소거부터 시작하여 Apple II의 상태를 제어합니다.",
    "keyboardButtons": "caps lock 키가 켜져 있으면 입력하는 모든 문자가 대문자가 됩니다.",
    "altArrowKeys": "다음 키는 {{modKey}} 키가 키보드 단축키에 사용되는지 Apple II Open Apple 키에 사용되는지를 결정합니다. 마지막 키는 화살표 키를 Apple II 조이스틱으로 사용할 수 있는지를 결정합니다.",
    "clearCookies": "Apple2TS는 현재 에뮬레이터 설정을 브라우저 쿠키로 자동 저장합니다. 이 버튼을 눌러 이러한 설정을 재설정하고 쿠키를 삭제하세요.",
    "debugWelcome": "Apple2TS는 6502 어셈블리 코드를 분석하고 디버그하기 위한 풍부한 도구 세트를 가지고 있습니다. 더 자세히 알아보려면 다음 버튼을 누르세요.",
    "debugIcon": "정보 탭의 벌레 아이콘을 클릭하여 디버그 패널을 보세요.",
    "debugPause": "일시 정지 버튼을 눌러 에뮬레이터의 실행을 일시 정지하거나 재개하세요.",
    "debugControls": "일시 정지했으므로 단계 건너뛰기, 들어가기, 나가기 버튼을 사용하여 디스어셈블된 코드를 단계별로 실행할 수 있습니다. 프로그램 카운터(PC)의 현재 주소로 빠르게 점프할 수도 있습니다.",
    "debugDisassembly": "여기서 16진 주소, 3글자 명령어, 그리고 모든 값이나 주소가 포함된 디스어셈블된 코드를 볼 수 있습니다. 녹색 값 위에 마우스를 올리면 현재 값이 포함된 툴팁이 나타납니다. 파란색 주소를 클릭하면 해당 위치로 스크롤됩니다. 왼쪽 여백을 클릭하여 중단점을 추가하거나 제거할 수도 있습니다.",
    "debugInfo": "가운데에 스택 덤프와 메모리 맵이 있습니다. 메모리 맵은 실시간으로 업데이트되어 현재 활성화된 메모리 뱅크를 보여줍니다.",
    "debugMemory": "마지막 섹션은 Apple II 메모리를 표시합니다. 드롭 목록을 사용하여 메모리의 다양한 부분을 검사할 수 있습니다. HGR 페이지 중 하나로 전환하면 메모리 위치와 연결된 고해상도 화면의 확대 보기를 얻을 수 있습니다. 16진 값이나 ASCII 문자열을 검색하고 메모리를 파일에 저장할 수도 있습니다.",
    "back": "뒤로",
    "close": "닫기",
    "last": "완료",
    "next": "다음",
    "nextLabelWithProgress": "다음 ({steps}단계 중 {step}단계)",
    "skip": "닫기",
    "guidedTour": "가이드 투어",
    "mainLabel": "가이드 투어: 메인",
    "settingsLabel": "가이드 투어: 설정",
    "debugLabel": "가이드 투어: 디버그"
  },
  "disk": {
    "drive1": "드라이브 1",
    "drive2": "드라이브 2",
    "hardDisk": "하드디스크",
    "eject": "디스크 꺼내기",
    "insert": "디스크 삽입",
    "writeProtected": "쓰기 보호",
    "readWrite": "읽기/쓰기",
    "empty": "비어있음",
    "loading": "로딩 중...",
    "selectDisk": "디스크 이미지 선택",
    "browse": "찾아보기",
    "newReleases": "새 릴리스",
    "writeProtectDisk": "디스크 쓰기 보호",
    "saveDiskToDevice": "디스크 저장",
    "saveDiskTo": "디스크 저장 위치",
    "saveDiskToMenu": "디스크 저장 위치 >",
    "addToFavorites": "즐겨찾기에 추가",
    "downloadDisk": "디스크 다운로드",
    "downloadWoz": "WOZ 디스크 이미지 다운로드",
    "downloadAndEjectDisk": "디스크 다운로드 및 꼼내기",
    "ejectDisk": "디스크 꼼내기",
    "ejectAllDisks": "모든 디스크 꺼내기",
    "saveDiskToOneDrive": "OneDrive에 디스크 저장",
    "saveDiskToGoogleDrive": "Google Drive에 디스크 저장",
    "loadDisk": "디스크 로드",
    "loadAdditionalDisks": "추가 디스크 로드...",
    "loadDiskFrom": "디스크 로드 위치",
    "loadDiskFromMenu": "디스크 로드 위치 >",
    "loadDiskFromDevice": "디스크 로드",
    "loadDiskFromDeviceReadOnly": "디바이스에서 디스크 로드 (읽기 전용)",
    "loadDiskFromDeviceReadWrite": "디바이스에서 디스크 로드 (읽기/쓰기)",
    "loadDiskFromInternetArchive": "Internet Archive에서 디스크 로드",
    "loadDiskFromOneDrive": "OneDrive에서 디스크 로드",
    "loadDiskFromGoogleDrive": "Google Drive에서 디스크 로드",
    "insertBlankDisk": "빈 디스크 삽입",
    "syncEveryMinute": "매분 동기화",
    "syncEvery5Minutes": "5분마다 동기화",
    "pauseSyncing": "동기화 일시 중지",
    "syncNow": "지금 동기화",
    "modified": "수정됨",
    "synced": "동기화됨",
    "diskImage": "디스크 이미지",
    "diskDrivesAndDevices": "디스크 드라이브 및 장치",
    "syncedAt": "동기화됨 {{date}}",
    "clickToLoadDiskImage": "디스크 이미지를 로드하려면 클릭",
    "clickToRemoveFromDiskCollection": "디스크 컬렉션에서 제거하려면 클릭",
    "clickToAddToDiskCollection": "디스크 컬렉션에 추가하려면 클릭",
    "byCreator": "작성자: {{creator}}",
    "clickToViewDetails": "상세 정보를 보려면 클릭",
    "standbyDisks": "대기 디스크 (클릭하여 디스크 변경)"
  },
  "help": {
    "title": "Apple2TS",
    "subtitle": "TypeScript Apple IIe 에뮬레이터",
    "credit": "(c) {{year}} Chris Torrence 및 Apple2TS 기여자",
    "keyboardShortcuts": "키보드 단축키",
    "shortcutsUnavailable": "{{keyMod}} 키가 Open Apple 키로 사용되는 동안에는 해당 키를 사용하는 에뮬레이터 단축키를 사용할 수 없습니다. Ctrl+0부터 Ctrl+5까지는 계속 에뮬레이터 속도를 선택할 수 있습니다.",
    "diskImages": "디스크 이미지:",
    "diskContainers": "압축 아카이브:",
    "multiDiskNotice": "다중 디스크 교체: 드라이브의 멀티 디스크 배지를 클릭하여 빠른 교체 메뉴를 엽니다. 다중 디스크 아카이브(.zip, .7z, .gz)는 모든 디스크를 교체 목록에 자동으로 마운트합니다.",
    "urlParameters": "선택적 URL 매개변수",
    "examples": "예제",
    "mobileInstructions": "모바일 플랫폼:",
    "tapScreen": "화면을 탭하여 키보드를 표시하세요.",
    "arrowKeys": "화살표 키, esc, 또는 tab 버튼을 눌러 해당 키를 에뮬레이터로 전송하세요.",
    "ctrlKey": "제어 문자를 보내려면 ctrl 버튼을 한 번 누르세요. 그런 다음 화면을 탭하여 키보드를 표시하고 원하는 키를 누르세요. ctrl 버튼은 자동으로 해제됩니다.",
    "ctrlLock": "여러 제어 문자를 보내려면 ctrl 버튼을 두 번 눌러 잠그세요(녹색 점으로 표시). 그런 다음 화면을 탭하여 키보드를 표시하고 원하는 키를 누르세요. ctrl 버튼을 다시 눌러 해제하세요.",
    "appleKeys": "open apple과 closed apple 키는 ctrl 키와 같은 방식으로 작동합니다.",
    "openAppleKey": "Open Apple: 왼쪽 Alt/Option 누름",
    "closedAppleKey": "Closed Apple: 오른쪽 Alt/Option 누름",
    "joystickKeys": "조이스틱 키: 숫자 패드 8/2/4/6 (7/9/1/3), 0/5, ./Enter",
    "onScreenKeyboard": "화면 키보드에서 CTRL 또는 ESC 사용 시:\n키를 한 번 눌러 활성화하고 원하는 키를 누르세요.",
    "urlParametersBody": "선택적 URL 매개변수는 URL에 물음표(?) 뒤에 추가하고, 여러 매개변수는 앰퍼샌드(&)로 구분합니다. 디스크 이미지를 지정하려면 #을 사용합니다. 예시는 링크 빌더 대화상자를 참조하세요.",
    "exampleLinks": {
      "totalReplayDebugging": "디버깅이 포함된 Total Replay",
      "totalReplayChoplifter": "Total Replay, Choplifter 로드, 임베디드 모드",
      "a2Desktop": "빠른 속도와 컬러 색상의 A2DeskTop 2MG",
      "embeddedBasic": "임베디드 Applesoft BASIC 프로그램",
      "binaryHexAddress": "16진수 주소가 있는 바이너리 파일"
    },
    "links": "링크",
    "resourceLinks": {
      "desktopApp": "Apple2TS 데스크톱 앙",
      "corsProxy": "Corsfix의 CORS 프록시",
      "silverCjkFont": "Silver CJK Pixel Font"
    }
  },
  "messages": {
    "loading": "로딩 중...",
    "error": "오류",
    "success": "성공",
    "confirm": "확인",
    "cancel": "취소",
    "ok": "확인",
    "on": "켜짐",
    "off": "꺼짐",
    "confirmTheme": "에뮬레이터를 다시 로드하고 이 테마를 지금 적용하시겠습니까?",
    "confirmReset": "모든 설정을 기본값으로 재설정하시겠습니까?",
    "fileNotFound": "파일을 찾을 수 없습니다",
    "invalidFile": "잘못된 파일 형식",
    "diskInserted": "디스크가 삽입되었습니다",
    "diskEjected": "디스크가 꺼내졌습니다"
  },
  "keyboard": {
    "space": "스페이스",
    "backspace": "백스페이스"
  },
  "audio": {
    "speaker": "스피커",
    "midi": "MIDI",
    "configuration": "오디오 설정",
    "volume": "볼륨",
    "mute": "음소거",
    "waveform": "파형"
  },
  "print": {
    "printer": "프린터",
    "print": "인쇄",
    "clear": "지우기",
    "save": "출력 저장",
    "dumpScreen": "현재 화면을 프린터로 출력",
    "dumpScreenInverse": "현재 화면 출력 (반전)",
    "sendToPrinter": "프린터로 보내기",
    "tearOff": "페이지 떼어내기 및 초기화",
    "printedPage": "인쇄된 페이지",
    "printerConfig": "프린터 구성",
    "pageLength": "페이지 길이",
    "pageLengthLetter": "11인치 (레터)",
    "pageLengthA4": "11.7인치 (A4)",
    "pageLengthTwelve": "12인치"
  },
  "device": {
    "machineConfiguration": "머신 구성",
    "midiDeviceSelect": "MIDI 장치 선택",
    "serialPortSelect": "직렬 포트 선택",
    "mockingboardWaveform": "Mockingboard 파형"
  },
  "collection": {
    "showApple2TSCollection": "Apple2TS 컴렉션 보기",
    "showNewReleases": "새 릴리스 보기",
    "showFavorites": "즐겨찾기 보기",
    "chooseDiskImage": "디스크 이미지 선택",
    "diskCollection": "디스크 컴렉션",
    "clickToShowDetails": "자세한 내용 보기",
    "clickToLoadDisk": "디스크 로드하려면 클릭",
    "diskIsNewRelease": "디스크가 새로운 릴리스입니다",
    "diskIsApple2TSCollection": "디스크가 Apple2TS 컴렉션의 일부입니다",
    "diskIsInternetArchive": "디스크가 Internet Archive의 일부입니다",
    "clickToRemoveFromCollection": "클릭하여 디스크 컬렉션에서 제거",
    "clickToAddToCollection": "클릭하여 디스크 컬렉션에 추가",
    "diskIsSyncedVia": "디스크가 동기화됨",
    "loadDiskIntoDrive": "드라이브에 디스크 로드",
    "exportDisksToHdv": "디스크를 HDV로 내보내기",
    "export": "내보내기",
    "clickToRemoveFromSelected": "클릭하여 선택에서 제거",
    "clickToAddToSelected": "클릭하여 선택에 추가",
    "reportExportIssue": "내보내기 문제 보고"
  },
  "debugControls": {
    "goBackInTime": "시간을 거슬러 올라가기",
    "takeSnapshot": "스냅샷 촬영",
    "goForwardInTime": "시간을 앞으로 진행",
    "saveStateWithSnapshots": "스냅샷과 함께 상태 저장",
    "resume": "다시 시작",
    "pause": "일시 정지",
    "trace": "추적",
    "tracing": "추적 중",
    "downloadTraceLog": "추적 로그 다운로드"
  },
  "fullscreen": {
    "fullScreen": "전체 화면"
  },
  "internetArchive": {
    "searchPlaceholder": "소프트웨어 이름을 입력하거나 위의 카테고리를 클릭하세요",
    "go": "검색"
  },
  "basic": {
    "newProgram": "새 프로그램",
    "runFromBeginning": "처음부터 실행",
    "break": "중단",
    "continueRunning": "계속 실행",
    "stepProgram": "프로그램 단계별 실행",
    "resumeOutput": "출력 재개",
    "freezeOutput": "출력 고정",
    "importProgram": "프로그램 가져오기...",
    "exportProgram": "프로그램 내보내기...",
    "renumberProgram": "프로그램 번호 다시 매기기",
    "rebuildProgram": "메모리에서 프로그램 재구성",
    "displaySettings": "디스플레이 설정",
    "autoLineNumbering": "자동 줄 번호 매기기",
    "capitalizeKeywords": "키워드 대문자로 변환",
    "rebuildWarning": "이 작업은 현재 프로그램을 Apple II 메모리에서 재구성된 버전으로 바꿉니다. 저장하지 않은 변경 사항은 지워집니다. 계속하시겠습니까?",
    "variable": "변수",
    "value": "값"
  },
  "expectin": {
    "runScript": "스크립트 실행",
    "stopScript": "스크립트 중지"
  },
  "saveDisassembly": {
    "title": "역어셈블 저장",
    "startAddress": "시작 주소 $",
    "endAddress": "종료 주소 $",
    "includeLabels": "심볼 레이블 포함",
    "separatorLines": "JMP, RTS 뒤에 구분선 추가"
  },
  "gamepad": {
    "useArrowKeys": "화살표 키를 조이스틱으로",
    "siriusJoyport": "Sirius 조이포트 모드"
  },
  "traceSettings": {
    "title": "추적 설정",
    "settings": "설정"
  },
  "linkBuilder": {
    "startupOptionsTab": "시작 옵션",
    "speedNames": {
      "warp": "터무니없는 속도"
    },
    "ramDiskSizes": {
      "512": "512",
      "1024": "1024",
      "4096": "4096",
      "8192": "8192"
    },
    "slots": {
      "configure": "슬롯 카드 설정",
      "slot": "슬롯 {{slot}}:",
      "cardNone": "없음 (비어 있음)"
    },
    "additionalDiskDrives": "추가 디스크 드라이브",
    "slot6Drive1": "슬롯 6 드라이브 1 (플로피 1)",
    "slot6Drive2": "슬롯 6 드라이브 2 (플로피 2)",
    "slot7Drive1": "슬롯 7 드라이브 1 (하드 드라이브 1)",
    "slot7Drive2": "슬롯 7 드라이브 2 (하드 드라이브 2)",
    "slot2Drive1": "슬롯 2 드라이브 1 (VERA SD)",
    "slot4Drive1": "슬롯 4 드라이브 1 (VERA SD)",
    "addAdditionalDisk": "교체할 추가 디스크 추가",
    "removeDisk": "이 디스크 제거",
    "addAnotherDisk": "다른 디스크 추가",
    "diskPlaceholder": "디스크 {num} 파일 이름 (예: sideB.woz|시나리오 디스크)"
  },
  "startup": {
    "welcome": "Apple2TS에 오신 것을 환영합니다",
    "subtitle": "TypeScript Apple II 에뮬레이터",
    "copyright": "(c) {{year}} C.Torrence + 협력자",
    "diskCollections": "디스크 컬렉션 아이콘을 클릭하여\n기본 디스크 또는 게임을 불러오세요."
  },
  "retroControl": {
    "machine": "머신",
    "fullscreen": "전체 화면",
    "diskCollection": "디스크",
    "diskDrives": "디스크 드라이브",
    "display": "디스플레이",
    "monitorMode": "모니터 모드",
    "monitorModeChoice": {
      "ntsc": "NTSC",
      "rgb": "RGB"
    },
    "sound": "소리",
    "options": "옵션",
    "skin": "스킨",
    "personalization": "개인 설정",
    "text": "텍스트",
    "background": "배경",
    "border": "테두리",
    "iigsColor": {
      "black": "검정",
      "red": "빨강",
      "darkBlue": "진한 파랑",
      "purple": "보라",
      "darkGreen": "진한 초록",
      "darkGray": "진한 회색",
      "mediumBlue": "파랑",
      "lightBlue": "하늘색",
      "brown": "갈색",
      "orange": "주황",
      "lightGray": "밝은 회색",
      "pink": "분홍",
      "lightGreen": "연두",
      "yellow": "노랑",
      "aquamarine": "아쿠아마린",
      "white": "흰색"
    },
    "keyboard": "키보드",
    "joystick": "조이스틱",
    "slots": "슬롯",
    "devices": "장치",
    "printerPort": "프린터 포트",
    "modemPort": "모뎀 포트",
    "quit": "종료",
    "apple2tsCollection": "Apple2TS 모음",
    "newReleases": "새 릴리스",
    "favorites": "즐겨찾기",
    "exportDisksToHdv": "디스크를 HDV로 내보내기",
    "noDiskDrivesAvailable": "사용 가능한 디스크 드라이브가 없습니다",
    "select": "선택",
    "open": "열기",
    "load": "불러오기",
    "go": "실행",
    "save": "저장",
    "clipboard": "클립보드",
    "cancelEsc": "취소:Esc",
    "color": "색상",
    "systemSpeed": "시스템 속도",
    "other": "기타",
    "timeMachine": "스냅샷",
    "ports": "포트",
    "language": "언어",
    "retroTheme": "레트로",
    "lowercaseInput": "소문자 입력",
    "openAppleKey": "오픈 애플 키",
    "sortOrder": "정렬",
    "card": {
      "empty": "비어 있음",
      "mockingboard": "Mockingboard"
    }
  }
}
